import { gql } from '../../../apollo/__generated__';

export const UPDATE_USER_MAX_SUPER_LIKES = gql(`
  mutation UpdateUserMaxSuperLikes($updateUserMaxSuperLikesInput: UpdateUserMaxSuperLikesInput!, $eventId: ID!) {
    updateUserMaxSuperLikes(updateUserMaxSuperLikesInput: $updateUserMaxSuperLikesInput) {
      id
      maxSuperLikes(eventId: $eventId)
    }
  }
`);
